import { render, staticRenderFns } from "./DeliveryAndPaymentPage.vue?vue&type=template&id=5e519083&"
import script from "./DeliveryAndPaymentPage.vue?vue&type=script&lang=js&"
export * from "./DeliveryAndPaymentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports